"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStreamsAptosOperation = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var dataTypes_1 = require("../../dataTypes");
exports.getStreamsAptosOperation = {
    method: 'GET',
    name: 'getStreamsAptos',
    id: 'aptosStreamsGetAll',
    groupName: 'aptosStreams',
    urlSearchParamNames: ['cursor', 'limit'],
    urlPathPattern: '/streams/aptos',
    firstPageIndex: 0,
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        limit: (0, common_core_1.maybe)(request.limit, String),
        cursor: request.cursor,
    };
}
function deserializeResponse(jsonResponse) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function (stream) { return dataTypes_1.AptosStream.create(stream); });
}
function serializeRequest(request) {
    return {
        cursor: request.cursor,
        limit: request.limit,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        cursor: jsonRequest.cursor,
        limit: jsonRequest.limit,
    };
}
//# sourceMappingURL=getStreamsAptosOperation.js.map